import type { IFilter } from "../models/Filter";
import type { IPartner } from "../models/Partner";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (id: string) => {
  return httpRequest.get(`/prt/business/${id}`);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/prt/business", { filter, offset });
};

export const update = async (id: string, data: IPartner | any) => {
  return httpRequest.put(`/prt/business/${id}`, data);
};

export const profile = async (id: string, data: IPartner | any) => {
  return httpRequest.put(`/prt/business/${id}/profile`, data);
};

export const create = async (data: IPartner | any) => {
  return httpRequest.post(`/prt/business`, data);
};

export const staffs = async ({ offset }: IFilter, businessId: string) => {
  return httpRequest.get(`/prt/business/staffs`, { businessId, offset });
};

export const users = async (businessId: string) => {
  return httpRequest.get(`/prt/business/user-select`, { businessId });
};

export const addUser = async (data: any) => {
  return httpRequest.post(`/prt/business/staff`, data);
};

export const deleteUser = async (id: string) => {
  return httpRequest.del(`/prt/business/staff/${id}`);
};

export const activate = async (id: string, isActive: boolean) => {
  return httpRequest.put(`/prt/business/${id}/status`, { isActive });
}
